// 编辑器store
import {observable, computed, action, makeObservable, flow, toJS} from 'mobx';
import _ from 'lodash';
import {getGoodsInfo, getCategoryList, getPasterRecommend} from '../services';

const addSuffixToKeys = (obj, suffix) => {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [`${key}${suffix}`, value])
    );
};

export const hasMarketingResource = (templateInfo = []) => {
    try {
        return templateInfo.some(({elements = []}) => {
            return elements.some(({isModule, moduleType}) => isModule && moduleType === 'marketingImage');
        });
    }
    catch (e) {
        return false;
    }
};

export const groupMarketingResource = (templateInfo = [], goodsInfo = [], categoryList = []) => {
    const elementsMap = {};

    const allElements = [];
    templateInfo.forEach((item, idx) => {
        const {elements = []} = item;
        const marketingEles = elements.filter(ele => ele.isModule && ele.moduleType === 'marketingImage');
        elementsMap[idx] = marketingEles.map(item => {
            return {
                ...item,
                categoryName: categoryList.find(category => +category.category === +item.marketingType)?.name
            };
        });
        allElements.push(...marketingEles);
    });

    const allCategory = {};
    allElements.forEach(item => {
        const {marketingType} = item;
        if (marketingType) {
            if (!allCategory[marketingType]) {
                allCategory[marketingType] = [];
            }
            allCategory[marketingType].push(item);
        }
    });

    const params = Object.keys(allCategory).map(category => {
        const categoryName = categoryList.find(item => +item.category === +category)?.name;
        if (categoryName) {
            return {
                category_name: categoryName,
                paster_count: allCategory[category].length
            };
        }
        return null;
    }).filter(item => item);

    const payload = goodsInfo.map(goods => {
        const {goods_id} = goods;
        return {
            goods_id,
            params
        };
    });

    return {
        reqParams: payload,
        elementsMap
    };
};

// 使用商品信息 替换商品卡中标注内容
export const genderGoodsCard = (templateInfo = [], goodsInfo = [], goodsContent = {}, templateOrder = 1) => {
    const goodsCard
        = templateInfo
            .filter(item => item.isGoodsCard && item.isModule)
            .filter(item => ['goodsImage', 'title', 'sellingPoint', 'dashingPrice', 'presentPrice'].includes(item.moduleType));

    const keyMap = {};

    goodsCard.forEach(item => {
        if (keyMap[item.moduleType]) {
            keyMap[item.moduleType].push(item.canvasId);
        }
        else {
            keyMap[item.moduleType] = [item.canvasId];
        }
    });

    if (keyMap.sellingPoint?.length) {
        keyMap.sellingPoint = keyMap.sellingPoint.sort((a, b) => a.sellingPointOrder - b.sellingPointOrder);
    }

    const goodsCardContent = goodsCard.reduce((acc, cur) => {
        return Object.assign(acc, {
            [cur.canvasId]: {
                name: cur.name,
                url: cur.url
            }
        });
    }, {});

    const goodsList = goodsInfo.map(item => item.goods_id);
    const goodsCardDetail = goodsList.reduce((acc, cur) => {
        return Object.assign(acc, {
            [cur]: _.cloneDeep(goodsCardContent)
        });
    }, {});

    try {
        Object.keys(goodsContent).map(item => {
            const curGoodsContent = goodsContent[item];

            Object.keys(keyMap).map(key => {
                switch (key) {
                    case 'goodsImage':
                        const {cover_url} = curGoodsContent;
                        if (Object.values(cover_url)[0]
                            && goodsCardDetail[item][keyMap.goodsImage[0]]?.url) {
                            goodsCardDetail[item][keyMap.goodsImage[0]].url = Object.values(cover_url)[0];
                        }
                        break;
                    case 'title':
                        const {title} = curGoodsContent;
                        if (title
                            && goodsCardDetail[item][keyMap.title[0]]?.name) {
                            const formatTitle = title.length > 8 ? title.slice(0, 5) + '...' : title;
                            goodsCardDetail[item][keyMap.title[0]].name = formatTitle;
                        }
                        break;
                    case 'sellingPoint':
                        const {slogan} = curGoodsContent;
                        if (slogan) {
                            const parsedSlogan = JSON.parse(slogan);
                            parsedSlogan.forEach((it, index) => {
                                if (it.name
                                        && goodsCardDetail[item][keyMap.sellingPoint[index]]
                                        && goodsCardDetail[item][keyMap.sellingPoint[index]]?.name) {
                                    goodsCardDetail[item][keyMap.sellingPoint[index]].name = it.name;
                                }
                            });
                        }
                        break;
                    case 'dashingPrice':
                        const {reserve_price} = curGoodsContent;
                        if (reserve_price
                            && goodsCardDetail[item][keyMap.dashingPrice[0]]?.name) {
                            goodsCardDetail[item][keyMap.dashingPrice[0]].name = reserve_price;
                        }
                        break;
                    case 'presentPrice':
                        const {price} = curGoodsContent;
                        if (price
                            && goodsCardDetail[item][keyMap.presentPrice[0]]?.name) {
                            goodsCardDetail[item][keyMap.presentPrice[0]].name = price;
                        }
                        break;
                }
            });
        });
    }
    catch (e) {
        console.error(e, 'parse goodsCardDetail error');
    }

    return addSuffixToKeys(goodsCardDetail, `_${templateOrder}`);
};

export const calculatePasterIds = (elements) => {
    let videoCount = 0;
    let videoIds = [];
    let topImageCount = 0;
    let topImageIds = [];
    let sideImageCount = 0;
    let sideImageIds = [];
    let bottomImageCount = 0;
    let bottomImageIds = [];
    let goodsCardCount = 0;
    let goodsCardIds = [];
    let marketingImageIds = [];
    let marketingImageCount = 0;
    elements.forEach(item => {
        if (!item.isModule) {
            return;
        }

        switch (item.moduleType) {
            case 'video':
                videoCount++;
                videoIds.push(item.canvasId);
                break;
            case 'image':
                switch (item.modulePos) {
                    case 'top':
                        topImageCount++;
                        topImageIds.push(item.canvasId);
                        break;
                    case 'side':
                        sideImageCount++;
                        sideImageIds.push(item.canvasId);
                        break;
                    case 'bottom':
                        bottomImageCount++;
                        bottomImageIds.push(item.canvasId);
                        break;
                }
                break;
            case 'marketingImage':
                if (item.marketingType) {
                    marketingImageCount++;
                    marketingImageIds.push(item.canvasId);
                }
                break;
            case 'goodsImage':
            case 'title':
            case 'sellingPoint':
            case 'dashingPrice':
            case 'presentPrice':
                goodsCardCount++;
                goodsCardIds.push(item.canvasId);
                break;
        }
    });

    return {
        videoCount,
        videoIds,
        topImageCount,
        topImageIds,
        sideImageCount,
        sideImageIds,
        bottomImageCount,
        bottomImageIds,
        goodsCardCount,
        goodsCardIds,
        marketingImageIds,
        marketingImageCount
    };
};

export class ScriptStore {
    choosedGoods = [];
    choosedCharacter = {};
    choosedTemplate = {};

    templateInfo = []; // 当前分镜模板信息

    totalTemplateInfo = []; // 解析后整组模板信息
    activeTemplatePageIndex = ''; // 当前模板分镜

    // key = `${goods_id}_${type}_${template_index}_${index}` 根据index映射pasterCount中canvasId
    // type: video topImage sideImage bottomImage
    pasterMap = {};
    pasterMapChanged = 0;

    goodsInfoMap = {};

    /**
     * {
     *  [goods_id]: {
     *      [canvasId]: {
     *          name: 'xxx',
     *          url: 'xxx'
     *      }
     *  }
     * }
    */
    goodsCardContent = {}; // 商品卡内容

    marketingImageCategory = [];
    marketingImageAuth = false;

    constructor() {
        makeObservable(this, {
            choosedGoods: observable,
            choosedCharacter: observable,
            choosedTemplate: observable,
            pasterMap: observable,
            pasterMapChanged: observable,
            templateInfo: observable,
            totalTemplateInfo: observable,
            activeTemplatePageIndex: observable,
            goodsInfoMap: observable,
            goodsCardContent: observable,
            marketingImageCategory: observable,

            pasterCount: computed,
            goodsCardInfo: computed,

            setChoosedGoods: action,
            setChoosedCharacter: action,
            setChoosedTemplate: action,
            addPaster: action,
            setTotalTemplateInfo: action,
            changeActivePage: action,
            updateGoodsCard: action,
            getMarketingImageCategory: action
        });
    }

    get pasterCount() {
        return calculatePasterIds(this.templateInfo);
    };

    get goodsCardInfo() {
        return this.templateInfo.filter(item => item.isGoodsCard);
    };

    setChoosedGoods = flow(function* (goods, customerAcquisitionAuth = false) {
        this.choosedGoods = goods;

        if (goods.length && !customerAcquisitionAuth) {
            const {errno, data} = yield getGoodsInfo({
                idList: goods.map(item => String(item.goods_id))
            });
            if (errno === 0) {
                this.goodsInfoMap = data;

                try {
                    this.marketingImageAuth = Object.values(data).some(item => item.is_healthy_goods);

                    if (this.totalTemplateInfo?.length && this.choosedGoods?.length && Object.keys(data).length) {
                        this.goodsCardContent = this.totalTemplateInfo.reduce((acc, cur, curIdx) => {
                            const genderRes = genderGoodsCard(cur.elements, this.choosedGoods, data, curIdx + 1);
                            return {
                                ...acc,
                                ...genderRes
                            };
                        }, {});
                    }
                }
                catch (e) {
                    console.log(e);
                }
            }
        }
        else {
            this.marketingImageAuth = false;
            this.goodsCardContent = {};
        }
    }).bind(this);

    getMarketingImageCategory = flow(function* () {
        if (this.marketingImageCategory.length) {
            return this.marketingImageCategory;
        }
        const res = yield getCategoryList({
            attribution: 9
        });
        if (res && res.errno === 0) {
            const list = res?.data || [];
            this.marketingImageCategory = list;
            return list;
        }
        return [];
    }).bind(this);

    setChoosedCharacter = (character) => {
        this.choosedCharacter = character;
    };

    setChoosedTemplate = (template) => {
        this.choosedTemplate = template;
    };

    addPaster = (key, value) => {
        this.pasterMap[key] = value;
        this.pasterMapChanged++;
    };

    changeActivePage = (pageIndex) => {
        const target = this.totalTemplateInfo.find(item => item.page_index === pageIndex);

        const {elements} = target || {};
        this.templateInfo = elements;
        this.activeTemplatePageIndex = pageIndex;
    };

    setTotalTemplateInfo = flow(function* (templateInfo = [], useGoodsCardFilter) {
        if (templateInfo.length === 0) {
            this.activeTemplatePageIndex = '';
            this.templateInfo = [];
            this.totalTemplateInfo = [];
            return;
        }

        const firstTemplate = templateInfo[0];
        const {elements: templateElementList, page_index} = firstTemplate || {};
        this.activeTemplatePageIndex = page_index;
        this.templateInfo = templateElementList?.filter(item => (useGoodsCardFilter ? !item.isGoodsCard : true));

        this.totalTemplateInfo = templateInfo.map(item => {
            const newElements = item.elements?.filter(element => (useGoodsCardFilter ? !element.isGoodsCard : true));
            return {
                ...item,
                elements: newElements
            };
        });

        if (templateInfo?.length && this.choosedGoods?.length && Object.keys(this.goodsInfoMap).length) {
            this.goodsCardContent = this.totalTemplateInfo.reduce((acc, cur, curIdx) => {
                const genderRes = genderGoodsCard(cur.elements, this.choosedGoods, this.goodsInfoMap, curIdx + 1);
                return {
                    ...acc,
                    ...genderRes
                };
            }, {});
        }

        if (templateInfo?.length && this.choosedGoods?.length && hasMarketingResource(templateInfo)) {
            if (!this.marketingImageCategory?.length) {
                yield this.getMarketingImageCategory();
            }
            const {reqParams, elementsMap} = groupMarketingResource(this.totalTemplateInfo, this.choosedGoods, this.marketingImageCategory);

            for (const reqParam of reqParams) {
                const res = yield getPasterRecommend(reqParam);

                if (res.errno === 0) {
                    try {
                        const prepareImages = {};
                        const {data} = res;
                        const {goods_id} = reqParam;
                        for (let i = 0; i < this.totalTemplateInfo.length; i++) {
                            const curTemplateMarketingImages = elementsMap[i] || [];
                            curTemplateMarketingImages.forEach((item, index) => {
                                const key = `${goods_id}_marketingImage_${i + 1}_${index}`;

                                const {categoryName} = item;
                                if (data && data[categoryName] && data[categoryName].length) {
                                    const target = data[categoryName].shift();
                                    const {paster_img_name, paster_img_url} = target;
                                    prepareImages[key] = {
                                        name: paster_img_name,
                                        url: paster_img_url
                                    };
                                }
                            });
                        }

                        this.pasterMap = {
                            ...this.pasterMap,
                            ...prepareImages
                        };
                        this.pasterMapChanged++;
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
            }
        }
    }).bind(this);

    updateGoodsCard = (goodsId, key, value) => {
        this.goodsCardContent[goodsId][key] = value;
    };
}
